@if (isScan) {
    <div class="app-wrapper">
        @if (showHeader) {
            <div class="scan-header">
                <span>{{ errorMessage }}</span>
                <ng-template #title></ng-template>
            </div>
        }
        <div class="scanner-display">
            <div
                id="scanner"
                [style]="'height: ' + height"
            ></div>
        </div>
        @if (showResults) {
            <div class="scan-results">
                @if (codeDetection) {
                    <div
                        class="scan-detection"
                        (click)="removeCodeDetection()"
                    >
                        <div class="scan-results-type-name">
                            {{ codeDetection.typeName }}
                        </div>
                        <div class="scan-results-data">
                            {{ codeDetection.data }}
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}

<br />

@if (initialized && !barcodeReader && showStartButton) {
    <div class="scan-actions">
        <button
            [disabled]="busy"
            class="btn btn-save btn-lg"
            (click)="startScanning()"
        >
            {{ scanningBtnText }}
        </button>
    </div>
}
@if (initialized && barcodeReader && showCloseButton) {
    <div class="scan-actions">
        <button
            [disabled]="busy"
            class="btn btn-save btn-lg"
            id="closeScanner"
            (click)="closeScanning()"
        >
            Close Scanner
        </button>
    </div>
}
